<template>
  <component
    :is="tag"
    class="text-dark-electric-blue flex gap-2 p-2 cursor-pointer hover:bg-police-blue items-center text-nowrap"
    data-test="screen-sharing-menu-item"
    @click="toggle()"
  >
    <wui-icon
      :name="isSharingScreen ? 'screenShareOffM' : 'screenShareM'"
      small
      class="text-white"
    />
    <span class="text-white">{{ isSharingScreen ? $t('calls.endScreenSharing') : $t('calls.startScreenSharing') }}</span>
  </component>
</template>
<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'

import { useToggleScreenSharing } from '../lib'

withDefaults(defineProps<{
  sessionId: string
  tag?: 'div' | 'li'
}>(), {
  tag: 'li',
})

const { isSharingScreen, toggle } = useToggleScreenSharing()
</script>
